const prod = {
	backend_url: "https://dev-api.iselfietest.com",
	resize_ratio: 2,
	version: "1.0.0",
	file_upload_length: 1048576,
	test_quota: 100,
	logIn_expire_time: 24 * 60 * 60 * 1000,
	test_expire_time: 24 * 60 * 60 * 1000,
	QRcode_URL: "https://dev-ui.iselfietest.com",
	test: {
		brightness_threshold: 80,
		lum_error_threshold: 15,
		lighting_adjustment_threshold: 5
	},
    shakebugs: {
        apiKey: "eaz21V3xuvpOKyVzPXU9NfSCtwbnmouSdgDNpioGiKxCUw0fHxW7t7O",
        appDomain: "sa-consumer.iselfietest.com",
    },
	enterprise: {
		url: "https://dev-enterprise-ui.iselfietest.com"
	},
		push_notification: {
				vapidKeys: {
					publicKey: "BFBGXXoV9L2vnRqpXLD3FoE5wh4Gd8GwjS_Zs233xnwqWLA5aUqhh_bmHINRoZQHzkBkm5_xE1Lgswoxy-XzRPQ",
				}
		},
		mixpanel: {
				projectToken: "d7def9b0026dae6e63d8a661d70f41f8"
		},
		defaultTimezone: "Etc/UTC",
		stripe: {
		pub_key: "pk_test_51O9pewKIBj7DgPMXmzOAYR13bm2yKxcQMPmU7NrcIiajqpMiZRXv9uR8rEMgfWviGkqTjYisBeCCN9uk9Eh9thJT00vvHrgJ7h",
	},
	defaultTrialDays: 3,
	region: "NA",
	description: [
		[
			{
				type: "link",
				data: [
					{
						text: "This tool is for informational purposes only. It is not intended for medical guidance and does not replace FDA-authorized tests. Per "
					},
					{
						link: "https://www.cdc.gov/coronavirus/2019-ncov/symptoms-testing/testing.html",
						text: "CDC guidelines"
					},
					{
						text: ", individuals without symptoms should:"
					}
				]
			},
			{
				type: "list",
				data: [
					{
						type: "link",
						data: [
							{
								text: "Wear a mask as soon as you find out you were "
							},
							{
								link: "https://www.cdc.gov/coronavirus/2019-ncov/your-health/if-you-were-exposed.html",
								text: "exposed"
							}
						]
					},
					{
						type: "text",
						data: "Test with an FDA-authorized COVID-19 test (e.g., a PCR test) no sooner than at least 5 full days after exposure"
					}
				]
			},
			{
				type: "text",
				data: "Should you develop symptoms, test immediately with an FDA-authorized test."
			}
		],
		[
			{
				type: "link",
				data: [
					{
						text: "This tool is for informational purposes only. It is not intended for medical guidance and does not replace FDA-authorized tests. Per "
					},
					{
						link: "https://www.cdc.gov/coronavirus/2019-ncov/symptoms-testing/testing.html",
						text: "CDC guidelines"
					},
					{
						text: ", individuals with symptoms should test immediately with an FDA-authorized COVID-19 test (e.g., a PCR test)."
					}
				]
			},
			{
				type: "link",
				data: [
					{
						text: "Roughly 75% of American adults have at least one risk factor for "
					},
					{
						link: "https://www.cdc.gov/coronavirus/2019-ncov/need-extra-precautions/people-with-medical-conditions.html",
						text: "progression to severe COVID‑19."
					},
					{
						text: " If you’ve had mild-to-moderate symptoms for fewer than 5 days and a healthcare provider confirms that you are at high-risk of severe COVID-19 progression, you may qualify for NIH-recommended antiviral treatment."
					}
				]
			},
		]
	],
	factSheetLink: 'https://iselfieprod.blob.core.windows.net/iselfie-prod-public/fact-sheets/iselfie-test-for-covid-fact-sheet.pdf',
    footer: {
        title: "iSelfie Test™ for Instant Health Screening",
        description: "The iSelfie Test™ - Version"
    },
    aboutUs: {
        medicalDivice: {
            text: "This product is labeled as a “medical device” in compliance with FDA guidelines to clearly indicate its regulated use. This IFU is intended for American."
        }
    }
};

const config = prod;
export default config;